// expose libraries if share module

window.EventEmitter = require("eventemitter3");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const jQuery = require("jquery");

if (window.jQuery) {
  console.log("use default jQuery");
} else {
  window.jQuery = jQuery;
}
window.$ = window.jQuery;

window.SmoothScroll = require("smooth-scroll");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const gsapAll = require("gsap/all");

window.gsap = gsapAll.gsap;
window.gsap.registerPlugin(gsapAll.ScrollTrigger);

window.swiper = require("swiper");

{
  const {
    Swiper,
    Autoplay,
    EffectFade,
    EffectCoverflow,
    Navigation,
    Pagination,
  } = window.swiper;
  Swiper.use([Autoplay, EffectFade, EffectCoverflow, Navigation, Pagination]);
}
